import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import DelBtn from "../../../component/atoms/button/delBtn";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import GoBack from "../../../component/molecules/goBack";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import Modal from "../../../component/templates/Modal";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import PretendardText from "../../../component/atoms/text/pretendardText";
import styled from "styled-components";
import LectureApi from "../../../api/lecture.api";
import moment from "moment";

const OnBoardingDetail = () => {
  const navigate = useNavigate();
  let { id } = useParams();

  // mounted
  useEffect(() => {
    getOnboardingInfo();
  }, []);

  // ----- 정보 가져오기
  const [onBoardingInfo, setOnBoardingInfo] = useState({
    answer: ["", "", "", "", "", "", "", "", "", ""],
  });

  const getOnboardingInfo = async () => {
    try {
      const response = (await LectureApi.getOnboardingById(id)).data.data.content;

      setOnBoardingInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 삭제
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      const data = {
        ids: [id],
      };
      await LectureApi.delOnboarding(data);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <DelBtn onClick={() => setDeleteModalOpen(true)} />
            </div>
          </DetailTop>

          <DetailPage>
            <DetailPageTitle>상세보기</DetailPageTitle>
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <DetailPageForm>
                <DetailFormTitle>아이디</DetailFormTitle>
                <DetailFormText>{onBoardingInfo.member?.account}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>이름</DetailFormTitle>
                <DetailFormText>{onBoardingInfo.member?.name}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>참여일</DetailFormTitle>
                <DetailFormText>{moment(onBoardingInfo.createdAt).format("YYYY/MM/DD")}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>1번 질문</DetailFormTitle>
                <div>
                  <QuestionText>직업이 어떻게 되시나요?</QuestionText>
                  <DetailFormText>{onBoardingInfo.answer[0]}</DetailFormText>
                </div>
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>2번 질문</DetailFormTitle>
                <div>
                  <QuestionText>현재 고정 연수입은 대략 어느 정도 인가요?</QuestionText>
                  <DetailFormText>{onBoardingInfo.answer[1]}</DetailFormText>
                </div>
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>3번 질문</DetailFormTitle>
                <div>
                  <QuestionText>대출을 통해 구매하려는 주택의 가격 범위는?</QuestionText>
                  <DetailFormText>{onBoardingInfo.answer[2]}</DetailFormText>
                </div>
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>4번 질문</DetailFormTitle>
                <div>
                  <QuestionText>대출을 통해 구매하려는 주택의 용도는 무엇인가요?</QuestionText>
                  <DetailFormText>{onBoardingInfo.answer[3]}</DetailFormText>
                </div>
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>5번 질문</DetailFormTitle>
                <div>
                  <QuestionText>정부 주도 주택 관련 대출에 대해 알고 계신가요?</QuestionText>
                  <DetailFormText>{onBoardingInfo.answer[4]}</DetailFormText>
                </div>
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>6번 질문</DetailFormTitle>
                <div>
                  <QuestionText>현재 주택구입을 위해 모아둔 자금은?</QuestionText>
                  <DetailFormText>{onBoardingInfo.answer[5]}</DetailFormText>
                </div>
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>7번 질문</DetailFormTitle>
                <div>
                  <QuestionText>임장 경험 또는 부동산 중개인과 상담 경험이 어떻게 되나요?</QuestionText>
                  <DetailFormText>{onBoardingInfo.answer[6]}</DetailFormText>
                </div>
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>8번 질문</DetailFormTitle>
                <div>
                  <QuestionText>현재 보유한 주택의 갯수는?</QuestionText>
                  <DetailFormText>{onBoardingInfo.answer[7]}</DetailFormText>
                </div>
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>9번 질문</DetailFormTitle>
                <div>
                  <QuestionText>현재 가장 관심 있는 투자 목적의 부동산 종류는?</QuestionText>
                  <DetailFormText>{onBoardingInfo.answer[8]}</DetailFormText>
                </div>
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>10번 질문</DetailFormTitle>
                <div>
                  <QuestionText>LTV,DTI,DSR에 대한 이해 정도는 어떠한가요?</QuestionText>
                  <DetailFormText>{onBoardingInfo.answer[9]}</DetailFormText>
                </div>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>관심 카테고리</DetailFormTitle>
                <DetailFormText>{onBoardingInfo.answer[10]}</DetailFormText>
              </DetailPageForm>
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {deleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDeleteModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : null}
    </>
  );
};

export default OnBoardingDetail;

const QuestionText = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 400;
  line-height: 21.25px;
  color: #adb4ba;
`;
